import mgr from "../../security/security.js";
import * as api from '../Services/api'
import DashboardUserProfile from "../../objs/DashboardUserProfile.ts";

export const state = {
  isAuthenticated: false,
  user: '',
  requiresAuth: false,
  dashboardUser: new DashboardUserProfile(),
  
};
export const mutations = {
  setUser(state, payload)
  {
    state.user = payload;
  },
  setRequiresAuth(state, payload)
  {
    state.requiresAuth = payload;
  },
  setIsAuthenticated(state, payload)
  {
    state.isAuthenticated = payload;
  }

};
export const getters = {
 
};
export const actions = {
  async getDashboardProfile({ commit, state }) {
    console.log("Getting dashboard profile action");
    commit("uxModule/setShowLoader", true, {
      root: true
    });
    var omniId = state.user.profile.sub;
    var sysUserResult = await api.getUser(omniId);
    var sysUser = sysUserResult.data;
    state.dashboardUser.id = omniId;
    state.dashboardUser.userName = sysUser.userName;
    state.dashboardUser.firstName = sysUser.firstName;
    state.dashboardUser.lastName = sysUser.lastName;
    state.dashboardUser.email = sysUser.email;
    state.dashboardUser.title = sysUser.roles[0];
    state.dashboardUser.legacySystemId = sysUser.legacySystemId;
    commit("uxModule/setShowLoader", false, {
      root: true
    });
  },
   
  //Shallow authentication is useful if we want to get the user from cache, even for a page where login is not required.
  async shallowAuthenticate({ commit, state, dispatch })
  {
    await mgr.signinSilent().then(user =>
    {
    }).catch(e =>
    {
    });
 
    let user = await mgr.getUser();
    if (!!user)
    {
      state.user = user;
      //Here, load whatever user data is specific to the application.
      if (state.dashboardUser.id == "") {
        await dispatch("getDashboardProfile");
      }
      state.isAuthenticated = true;
    } else
    {
      state.isAuthenticated = false;
    }
  },
  async authenticate({ commit, state, dispatch }, returnPath)
  {
    commit("uxModule/setShowLoader", true, {
      root: true
    });
    let user = await mgr.getUser();
    if (!!user)
    {
      state.user = user;
      //Here, load whatever user data is specific to the application.
      if (state.dashboardUser.id == "") {
        await dispatch("getDashboardProfile");
      } 
      state.isAuthenticated = true;
      commit("uxModule/setShowLoader", false, {
        root: true
      });
    } else
    {
      var signedIn = await returnPath
        ? mgr.signinRedirect({ state: returnPath })
        : mgr.signinRedirect();
      commit("uxModule/setShowLoader", false, {
        root: true
      });
    }
  },
  async logout({ commit, state })
  {
    state.isAuthenticated = false;
    await mgr.signoutRedirect();
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
